import { Component } from '@angular/core';
import { DialogService } from 'src/app/core/components/dialog/dialog.service';
import { DepotIframeComponent } from './depot-iframe/depot-iframe.component';

declare var openModal: any;
@Component({
    selector: 'div [deposito-pct]',
  templateUrl: 'deposito-pct.component.html'
})

export class DepositoPctComponent {
  urlInput: string;

  constructor (private modal: DialogService) {}

  inizializza(urlIframe: string) {
    this.urlInput = urlIframe;
    const ref = this.modal.open(DepotIframeComponent, {
      data: {
        style: { width: "90%" },
        url : this.urlInput
      }
    })

    ref.afterClosed.subscribe(() => this.resetUrl());
  }

  resetUrl() {
    this.urlInput = null;
  }
}
